import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Info from "@insite/mobius/Icons/Info";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface RandomLengthItemStyles {
    randomLengthItem?: InjectableCss;
    customPropertyContainer?: InjectableCss;
    viewLinkIcon?: InjectableCss;
}

export const randomLengthItemStyles: RandomLengthItemStyles = {
    randomLengthItem: {
        css: css`
            font-size: 13px;
            font-weight: normal;
            color: rgb(46, 100, 176);
            margin-top: 15px;
        `,
    },
    customPropertyContainer: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-direction: column;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    viewLinkIcon: {
        css: css`
            position: relative;
            padding-left: 25px;
            svg {
                position: absolute;
                top: 6px;
                width: 20px;
                left: 0;
                color: #2e64b0;
            }
        `,
    },
};

const styles = randomLengthItemStyles;

interface OwnProps {
    displayRandomLength: boolean;
}

type props = OwnProps;

const RandomLengthComponent: React.FC<props> = ({ displayRandomLength }) => {
    return (
        <StyledWrapper {...styles.customPropertyContainer}>
            {displayRandomLength ? (
                <StyledWrapper {...styles.randomLengthItem}>
                    <Icon {...styles.viewLinkIcon} src={Info} />
                    {translate("Sold in random lengths. Invoice will reflect actual quantity shipped.")}
                </StyledWrapper>
            ) : null}
        </StyledWrapper>
    );
};

export default RandomLengthComponent;
